/**
 * Cross-platform S3 helper
 * Checks for NEXT_PUBLIC_CDN_URL (web) or EXPO_PUBLIC_CDN_URL (mobile)
 */
import { getS3ObjectURLShared } from '@shared/all/helpers/s3';

export { getS3ObjectURLShared };

export const getS3ObjectURL = (key: string): string => {
  const prefix =
    process.env.EXPO_PUBLIC_CDN_URL || // Mobile EAS cloud
    process.env.NEXT_PUBLIC_CDN_URL; // Client or mobile local dev
  if (!prefix) {
    throw new Error('CDN_URL environment variable is not defined');
  }
  return getS3ObjectURLShared(key, prefix);
};
